import { Component, type ErrorInfo, type ReactNode } from 'react';

type State = { failed: boolean };

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) console.error(error, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="state-page" id="main-content">
          <h1>The page stopped unexpectedly</h1>
          <p>Your saved progress is still in this browser.</p>
          <button className="primary-button" type="button" onClick={() => window.location.reload()}>
            Reload the fieldbook
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
